import React, { useState } from 'react';
import { doc, setDoc } from "firebase/firestore";
import { db } from '../firebaseConfig';
import './TickerSection.css';

const TickerSection = () => {
  const [en, setEn] = useState("");
  const [ur, setUr] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleUpdate = async () => {
    if (!en || !ur) return alert("Please fill both English and Urdu fields!");
    
    setLoading(true);
    setMessage("");

    try {
      // setDoc use kiya hai jo document na hone par create bhi karega
      await setDoc(doc(db, "settings", "tickerData"), {
        tickerEN: en,
        tickerUr: ur,
        updatedAt: new Date().toISOString()
      });
      
      setMessage("Ticker successfully updated! ✅");
      setEn(""); setUr("");
    } catch (e) {
      console.error("Error updating document: ", e);
      setMessage("Failed to update: " + e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ticker-admin-container">
      <h2>Live News Ticker Management</h2>
      {message && <p className="status-message">{message}</p>}
      
      <div className="input-group">
        <label>English News:</label>
        <input type="text" value={en} onChange={(e) => setEn(e.target.value)} placeholder="Enter English Ticker..." />
      </div>
      
      <div className="input-group">
        <label>Urdu News:</label>
        <input type="text" value={ur} onChange={(e) => setUr(e.target.value)} placeholder="تازہ ترین خبریں درج کریں..." />
      </div>
      
      <button onClick={handleUpdate} disabled={loading}>
        {loading ? "Updating..." : "Update Website Ticker"}
      </button>
    </div>
  );
};

export default TickerSection;